import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { IamAuthService, MsalInterceptor } from '@cemex-core/msal-services-v1';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
class AuthInterceptorSimple implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorFactory {
  constructor(
    private injector: Injector,
    private iamService: IamAuthService,
  ) {}

  createInterceptor() {
    const url = window.location.href;
    const authUrl = `${window.location.protocol}//${window.location.host}/login`;
    const hosthUrl = `${window.location.protocol}//${window.location.host}`;

    if (url.includes(this.iamService.getPostLogoutRedirectUri()) || this.iamService.isLoginByIAM()) {
      sessionStorage.setItem('authIamStarted', 'true');
      return this.injector.get(MsalInterceptor);
    } else if (url === authUrl || url === hosthUrl || url === `${hosthUrl}/`) {
      sessionStorage.setItem('authIamStarted', 'false');
      return this.injector.get(AuthInterceptorSimple);
    } else {
      return this.injector.get(AuthInterceptorSimple);
    }
  }
}
